import { iws_event, iws_stopPropagation } from "./tools.ts";

export class IsiGridPagin {

    id: string;
    _build = false;
    _nbRecordJquery = null;
    _txtNbRecordJquery = null
    _txtPage: HTMLInputElement;
    currentPage = 1;
    pageCount = 1;
    isActivated = true
    recordCount = -1;
    recordPerPage = -1;
    txtPage: null;
    selectedRecordsCount = 0;
    gridPaging: any;
    gridPagingCmpId: string;

    /// <summary>
    ///     Classe de gestion de la pagination de la grille.
    /// </summary>
    /// <param name="gridId" type="String">
    ///     Id de la grille.
    /// </param> 
    constructor(gridId?: string) {
        this.id = gridId;
        this._build = false;
        this._nbRecordJquery = null;
        this._txtNbRecordJquery = null;
    }

    dispose() {
        /// <summary>
        ///     Libere la memoire utilise pour la gestion de la pagination de la grille.
        /// </summary>
        this._txtPage = null;
        this._nbRecordJquery = null;
        this._txtNbRecordJquery = null;
    }

    saveState() {
        ///  <summary>Sauve l'etat de l'objet a envoyer au serveur.</summary>
        isiApp.appState.currentPage = this.currentPage;
    }

    loadState() {
        ///  <summary>Charge l'etat de l'objet en provenance du serveur.</summary>
        this.currentPage = isiApp.appState.currentPage;
    }
    private _ensurePagingComponentId() {

        this.gridPagingCmpId = "AssociatedViewHeader_IsiPaging";
    }
    bindPagingEvents() {
        this._ensurePagingComponentId();
        const pagingEvents = (cp) => {
            this.gridPaging = cp;
            cp.add_onPageChange((sender, args) => {
                switch (args.eventType) {
                    case cp.eventType.next:
                        this.gridPaginClick("GotoNext", null, args);
                        break;
                    case cp.eventType.previous:
                        this.gridPaginClick("GotoBack", null, args);
                        break;
                    case cp.eventType.indexChange:
                        this.gridPaginClick("GotoPage", null, args);
                        break;
                }
            });

            this._majPagingOnValueChange(cp);
        };

        //Pagination dans l'associatedViewHeader
        uiCore.componentManager.whenComponentFound(this.gridPagingCmpId, pagingEvents);
    }
    /**
     * Fait la mise à jour de l'état du composant en fonction
     * des valeurs : nombre de pages, page courante ... 
     * */
    private _majPagingOnValueChange(cp) {
        if (cp) {
            if (this.pageCount && (this.pageCount > 1)) {
                cp.initValuesFromClient(this._txtPage.value, this.pageCount);
                jQuery("#" + cp.getId()).css("display", "flex");
                //cp.getJQueryElement().css("display", "flex");
            } else {
                cp.hide();
            }
        }
    }

    initPaging(gridId?: string) {
        this.id = gridId;
        this._initDomRefs();

    }

    /**
     * Gestion de la pagination de la grille.
     * @param {Boolean} activated Indique si on active ou non la pagination.
     * @param {Integer} pageCount Le nombre total de page.
     * @param {Integer} recordCount Le nombre total d'enregistrement.
     * @param {Integer} recordPerPage Le nombre d'enregistrement par page.
     */
    gridPaginActivated(activated: boolean, pageCount?: number, recordCount?: number, recordPerPage?: number) {
        this.isActivated = activated;

        if (this.isActivated && pageCount) {
            this.pageCount = pageCount;
        }

        if (recordCount) {
            this.recordCount = recordCount;
        }

        if (recordPerPage) {
            this.recordPerPage = recordPerPage;
        }

        // Affichage du nombre d'enregistrement
        if (this.isActivated) {
            this.displayRecordCount();
        }
        this._majPagingOnValueChange(this.gridPaging);
    }

    setCurrentPage(i) {
        /// <summary>
        ///     Affecte la page a la zone de saise de la pagination de la grille.
        /// </summary>
        /// <param name="i" type="Integer">
        ///     Numero de la page a affecter.
        /// </param>
        //AHME 31/12/2020 - PB0021116 : Sur une donnée associée, la recherche n'aboutait pas si le champ de pagination est vide.
        if (i == "") { i = "1"; }
        this._txtPage.value = i;
        this.currentPage = parseInt(i, 10);

    }

    displayRecordCount() {
        /// <summary>
        ///     Affiche le nombre d'enregistrement de la pagination de la grille.
        /// </summary>

        let begin;
        let end;
        if (this.recordPerPage > 0) {
            begin = 1 + (this.currentPage - 1) * this.recordPerPage;
            end = Math.min(this.currentPage * this.recordPerPage, this.recordCount);
        }

        if (begin && end) {
            this._nbRecordJquery.text(begin.isiToLocaleString() + " - " + this.emptyStringIfNotSet(end.isiToLocaleString()));
        } else {
            this._nbRecordJquery.text(". - . ");
        }

        if (this.recordCount !== -1) {
            this._txtNbRecordJquery.text(this.emptyStringIfNotSet(this.recordCount.toLocaleString()));
            if (screenCore.associatedViewManager.getHeader() !== null) {
                screenCore.associatedViewManager.getHeader().setCount(jQuery(".countDA").text(), this.pageCount);
            } else {
                // cas de la recherche formulaire on a pas de composant page header sur la da 
                jQuery(".associatedViewHeader .count .total").text(jQuery(".countDA").text());
            }


        }
    }

    emptyStringIfNotSet(i) {
        /// <summary>
        ///     Retourne une chaine vide si la valeur donnee n'a pas ete definie. 
        ///    C'est a dire, pour nous, c'est qu'elle est a -1.
        /// </summary>
        /// <param name="i" type="Integer">
        ///     Chaine a formater.
        /// </param>
        if (i === "-1" || i === -1) {
            return "";
        } else {
            return i;
        }
    }


    gridPaginClick(btn, event, args?) {
        //ARAN 21/10/2009 [DYSF32213]Modification de la fonction afin que la redirection ne se fasse que sur les 
        //boutons actif de la navigation

        const oEvent = iws_event(event);

        /// <summary>
        ///     Gestion des boutons de la pagination de la grille.
        /// </summary>
        /// <param name="btn" type="String">
        ///     Indique le type de bouton qui a effectue l'action.
        /// </param>
        // si la pagination n'est pas activee, on ne fait rien.
        if (!this.isActivated) {
            iws_stopPropagation(oEvent);
            return false;
        }
        // recupere le nombre de page courantes.
        let bMove = true;
        let bContinue = true;

        switch (btn) {
            case "GotoBack":
                if (this.gridPaging.isPrvButtonEnabled() && args.oldValue === args.value) {
                    bContinue = false;
                    bMove = false;
                }
                break;
            case "GotoNext":
                if (this.gridPaging.isNxtButtonEnabled() && args.oldValue === args.value) {
                    bContinue = false;
                    bMove = false;
                }
                break;
        }
        if (bContinue) {
            // definie la page courante.
            this.setCurrentPage(this.gridPaging.getCurrentPage());
        }
        if (!bMove) {
            iws_stopPropagation(oEvent);
        } else {
            // on desactive les boutons pour empecher les clicks intempestifs
            this.gridPaginActivated(false, this.pageCount);
        }

        if (bContinue) {
            poster();
        }

        // sauve l'etat de l'application et l'envoie au serveur.
        isiApp.uploadState();

        return bMove;

    }
    
    setSelectedRecordsCount(count) {
        /// <summary>
        ///     Permet de donner le nombre d'enregistrements selectionnes dans 
        ///     la grille, quelque soit la page affichee.
        /// </summary>
        this.selectedRecordsCount = count;
    }

    private _initDomRefs() {
        /// <summary>
        ///  Private : Initialise les references aux elements du DOM.
        /// </summary>

        if (!this._build) {
            this._nbRecordJquery = jQuery(document.getElementById(this.id + "_" + LABEL_NBRECORD));
            this._txtNbRecordJquery = jQuery(document.getElementById(this.id + "_" + LABEL_TXT_NBRECORD));
            this._txtPage = document.getElementById(this.id + "_txt") as HTMLInputElement;

            this._build = (this._nbRecordJquery != null);
        }
        return this._build;
    }

}
